import { useTranslation } from 'react-i18next';

export default function HeroSection() {
  const { t } = useTranslation();

  return (
    <section className="relative w-full min-h-screen flex flex-col items-center justify-center pt-20 pb-16 px-4 md:px-10 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20minimalist%20lifestyle%20background%20with%20gentle%20warm%20ivory%20and%20toasted%20almond%20tones%2C%20elegant%20product%20styling%20with%20subtle%20textile%20draping%20and%20organic%20ceramic%20elements%2C%20diffused%20natural%20window%20light%20creating%20delicate%20shadows%2C%20serene%20scandinavian%20interior%20atmosphere%2C%20refined%20editorial%20composition%20with%20airy%20negative%20space%20and%20tactile%20natural%20materials&width=1800&height=1200&seq=hero-bg-v2-2026&orientation=landscape"
          alt="Oopbuy Spreadsheet Hintergrund"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-background-50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto text-center">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-background-50/80 backdrop-blur-sm border border-background-300 mb-8">
          <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
          <span className="text-xs font-medium text-foreground-700">{t('hero.badge')}</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 leading-tight mb-6">
          {t('hero.title_line1')}<br />
          <span className="text-accent-300">{t('hero.title_line2')}</span><br />
          {t('hero.title_line3')}
        </h1>

        <p className="text-base md:text-lg text-background-200 max-w-xl mx-auto mb-10 leading-relaxed">
          {t('hero.subtitle')}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-900 text-background-50 text-sm md:text-base font-medium hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
          >
            {t('hero.cta_primary')}
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50/90 backdrop-blur-sm text-foreground-900 text-sm md:text-base font-medium hover:bg-background-50 transition-all whitespace-nowrap cursor-pointer border border-background-200"
          >
            {t('hero.cta_secondary')}
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </div>

        {/* Stats */}
        <div className="flex flex-wrap items-center justify-center gap-8 md:gap-12 mt-14">
          {[
            { value: '10.000+', labelKey: 'hero.stat_products' },
            { value: '500+', labelKey: 'hero.stat_sellers' },
            { value: '4.9/5', labelKey: 'hero.stat_rating' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-background-50">{stat.value}</p>
              <p className="text-xs md:text-sm text-background-300 mt-1">{t(stat.labelKey)}</p>
            </div>
          ))}
        </div>

        {/* Search bar */}
        <div className="max-w-md mx-auto mt-10">
          <div className="flex items-center gap-0 bg-background-50/95 backdrop-blur-sm rounded-full border border-background-200 overflow-hidden">
            <div className="flex items-center pl-5 text-foreground-400">
              <i className="ri-search-line text-lg"></i>
            </div>
            <input
              type="text"
              placeholder={t('hero.search_placeholder')}
              className="flex-1 px-3 py-3 text-sm text-foreground-800 bg-transparent placeholder:text-foreground-400 focus:outline-none"
            />
            <button className="px-5 py-3 bg-accent-500 text-background-50 text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer">
              {t('hero.search_button')}
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}